import AddEditPersonForm from "./AddEditPersonForm";
import PersonAssociatedVersionsSection from "./sections/PersonAssociatedVersionsSection";
import PersonConnectionsSection from "./sections/PersonConnectionsSection";
import PersonImpliesSection from "./sections/PersonImpliesSection";
import PlaceOfPersonSection from "./sections/PlaceOfPersonSection";

const AddEditPersonPage: React.FC = () => {
  return (
    <AddEditPersonForm
      sections={(person) => [
        <PersonAssociatedVersionsSection
          personId={person._key}
          personalRoles={person.personal_roles}
          teamRoles={person.team_roles}
        />,
        <PersonConnectionsSection person={person} />,
        <PersonImpliesSection person={person} />,
        <PlaceOfPersonSection person={person} />,
      ]}
    />
  );
};

export default AddEditPersonPage;
